export const getSeoProps = (
	defaultSeoProps: DogsTrust.SEOMetaProps,
	fallbackProps: DogsTrust.SEOMetaProps,
): DogsTrust.SEOMetaProps => {
	if (defaultSeoProps === null) return fallbackProps;
	let newProps = { ...defaultSeoProps };
	// Make sure none of our values are set to 'null'
	for (const [key, value] of Object.entries(defaultSeoProps || {})) {
		if (value === null) {
			newProps = {
				...newProps,
				[key]: fallbackProps[key as keyof typeof fallbackProps],
			};
		}
	}

	return { ...fallbackProps, ...newProps };
};
